import React, { Component } from 'react';
import fire from './Firebase';
import List from './components/List';

class Login extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      email: '',
      password: ''
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  login(e) {
    e.preventDefault();
    fire.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then((u)=>{
        //window.location = 'list'; 
        window.location.href = '/list'
    }).catch((error) => {
        console.log(error);
        alert("You don't have priviledges to log in!")
      });
  }

  render() {
    return (
      <div className="container" style={{background:"#2d30bd", padding:"6%",marginTop:"5%", align:"center"}}>
       <div>
            <form>
                <div class="form-group">
                  <h3 style={{align:"center"}}>Tutor Login</h3><br></br>
                <label for="exampleInputEmail1">Email address</label>
                <input value={this.state.email} onChange={this.handleChange} type="email" name="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter tutor's email address" required/>
                <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
                </div>
                <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input value={this.state.password} onChange={this.handleChange} type="password" name="password" class="form-control" id="exampleInputPassword1" placeholder="Password"  required/>
                </div>
                <button type="submit" onClick={this.login} class="btn btn-primary">Login</button>
                <a href="http://mytutor.org.za"><p>Back to home page</p></a>
            </form>
      </div>
     </div> 
    );
  }
}
export default Login;
